module.exports = __webpack_public_path__ + "media/palenque/mayan-a1667c66.jpg";